<template>
	<div class="mode_main">
		<template v-for="(item,index) in pageData">
			<Banner v-if="item.type === 1" :bannerData='item'></Banner>
			<RichText v-if="item.type === 2 && item.content" :richTextData='item'></RichText>
			<TilText v-if="item.type === 3" :titleData='item'></TilText>
			<Product v-if="item.type === 4" :proData='item'></Product>
			<Movie v-if="item.type === 5" :movieData='item'></Movie>
			<SingleImg v-if="item.type === 6" @on-modeDtl="goProductDtl" :imgData='item'></SingleImg>
			<MultiImg v-if="item.type === 7" :imgData='item'></MultiImg>
			<Coupon v-if="item.type === 8" :couponData='item'></Coupon>
			<PromotionProduct v-if="item.type === 9||item.type === 10||item.type === 11" :proData='item'></PromotionProduct>
			<Graphic v-if="item.type === 12" :graphicData='item'></Graphic>
			<TextMode v-if="item.type === 13" :textData='item'></TextMode>
			<InputMode v-if="item.type === 14" :formData='item'></InputMode>
		</template>
	</div>
</template>
<script>
	import "../assets/css/mode.css"
	import Banner from '@/mode/banner'
	import RichText from '@/mode/richText'
	import TilText from '@/mode/titleText'
	import Product from '@/mode/product'
	import Movie from '@/mode/movie'
	import SingleImg from '@/mode/singleImg'
	import MultiImg from '@/mode/multiImg'
	import Coupon from '@/mode/coupon'
	import PromotionProduct from '@/mode/promotionProduct'
	import Graphic from '@/mode/graphic'
	import TextMode from '@/mode/textMode'
	import InputMode from '@/mode/inputMode'
	export default {
		components: {
			Banner,
			RichText,
			TilText,
			Product,
			Movie,
			SingleImg,
			MultiImg,
			Coupon,
			PromotionProduct,
			Graphic,
			TextMode,
			InputMode,
		},
		props:{
			pageData:{
				type:Array,
				default: () => [
					{
						"id":4,"type":1,
						"quantity":2,"height":400,
						"cutover_time":6,
						"button_shape":1,
						"button_color":"#fff",
						"banners":[
							{"id":123,"tag_line":"0","image":"https://www.wennoanimal.com/uploads/holograms/202105/31//admin_1622449079_BYCwgamKcO.jpg","path":"0"
							},
							{"id":124,"tag_line":"0","image":"https://www.wennoanimal.com/uploads/holograms/202106/28//admin_1624850151_zjKG1WjeHU.jpg","path":"0"
							}
						]
					},
					{
						"id": 1,
						"type": 2,
						"content": '<p>你好呀，哈哈哈哈哈</p>',
					},
					{
						"id":10,
						"type":3,
						"title":"欢迎来到Wenno，开启你的购物之旅~123",
						"icon":"https://www.wennoanimal.com/uploads/admin/202105/19/60a4e3a430030.png",
						"title_size":"16",
						"title_color":"#000000",
						"align":"center",
						"bg_color":"#ffffff",
						"bg_image":null,
						"path":null
					},
					{
						"id":7,"type":4,"label_show":1,"label_type":5,"list_style":"2","bg_color":"#fafafa",
						"product":[
							{"id":69,"product_info":{"id":69,"shop_category_id":37,"lang":"zh-CN","title":"Wenno 犀牛父子","description":"","image":["images/P26.jpg","files/ed6955f98c353881b63932d40156d2f7.png"],"on_sale":true,"sales":true,"rating":5,"sold_count":0,"review_count":0,"price":"118.00","sales_price":"69.00","rebate":"0.58","not_before":"2021-01-29 00:00:00","not_after":"2027-12-31 00:00:00","line":10,"status":0
						,"currency_code":"CNY","product_no":"12345","integral":0,"stock":100,"image_url":"https://www.wennoanimal.com/uploads/images/P26.jpg"}
							},
							{"id":70,"product_info":{"id":70,"shop_category_id":37,"lang":"zh-CN","title":"Wenno 长颈鹿父子","description":"","image":["images/P27.jpg","files/dcd2ae82d08ab31bff17c596a1ac19b4.jpg"],"on_sale":true,"sales":true,"rating":5,"sold_count":0,"review_count":0,"price":"118.00","sales_price":"69.00","rebate":"0.58","not_before":"2021-01-29 00:00:00","not_after":"2027-12-31 00:00:00","line":10,"status":0
							,"currency_code":"CNY","product_no":"1234","integral":0,"stock":100,"image_url":"https://www.wennoanimal.com/uploads/images/P27.jpg"}
							}
						]
					},
					{
						"id":3,"type":5,"height":200,"automatic":0,
						"movie":"https://www.wennoanimal.com/uploads/admin/202105/19/60a4b0dceab16.mp4"
					},
					{
						"id":14,"type":6,"height":200,
						"security_code_switch":0,"bg_color":"#ffffff",
						"single_image":[
							{"id":81,"image":"https://www.wennoanimal.com/uploads/holograms/202106/29//admin_1624932346_aKbkse3V54.png","path":"","is_hologram":0
							}
						]
					},
					{
						"id":4,
						"type":7,
						"height":200,
						"showcase_type":2,
						"security_code_switch":0,
						"bg_color":"#ffffff",
						"showcase_image":[
							{
								"id":172,
								"image":"https://www.wennoanimal.com/uploads/holograms/202105/19//admin_1621418384_Y9TOqWxf1s.png",
								"path":"/customPages/customDtl/customDtl?id=9",
								"is_hologram":0,
							},{
								"id":173,
								"image":"https://www.wennoanimal.com/uploads/holograms/202105/19//admin_1621418390_q4R8hWaUr0.png",
								"path":"/hologram/holiday/holiday",
								"is_hologram":0,
							},{
								"id":174,
								"image":"https://www.wennoanimal.com/uploads/holograms/202105/31//admin_1622448679_HsR8MPfynu.png","path":"/customPages/customDtl/customDtl?id=12",
								"is_hologram":0,
							},{
								"id":175,
								"image":"https://www.wennoanimal.com/uploads/holograms/202105/26//admin_1622018405_Z2ysbDAjGE.png","path":"/customPages/animals/animals",
								"is_hologram":0,
							}
						],
					},
					{
						"id":6,"type":8,"coupon_type":1,"bg_color":"#ffffff",
						"coupon":[
							{"id":15,"unclaimed_image":"https://www.wennoanimal.com/uploads/holograms/202106/28//admin_1624848983_NhFudhWumX.jpg","claim_image":"https://www.wennoanimal.com/uploads/holograms/202106/28//admin_1624848987_vZndPwPuRD.jpg","popup_image":"","point":0,"is_receive":0
							},{"id":14,"unclaimed_image":"https://www.wennoanimal.com/uploads/holograms/202106/07//admin_1623056410_HPO3giJs8R.png","claim_image":"https://www.wennoanimal.com/uploads/holograms/202106/09//admin_1623210556_hWfU9Musvb.png","popup_image":"","point":0,"is_receive":0
							}
						]
					},
					{
						"id":7,"type":9,"list_style":"2","bg_color":"#fafafa",
						"spikes_products":[]
					},
					{
						"id":11,"type":10,"list_style":"2","bg_color":"#fafafa",
						"full_discount_products":[]
					},
					{
						"id":5,"type":11,"list_style":"2","bg_color":"#fafafa",
						"group_products":[]
					},
					{
						"id": 1,
						"align": "center",
						"bg_color": "#ffffff",
						"color": "#000000",
						"created_at": "2021-07-29 14:31:37",
						"font_in_image_color": "red",
						"font_in_image_size": "14",
						"font_size": "16",
						"imageText": [{
							"created_at": "2021-07-29 14:32:08",
							"font_in_image": "搜索",
							"id": 3,
							"image": "https://www.wennoanimal.com/uploads/holograms/202107/29//admin_1627540312_NGqESn9dYo.jpg",
							"text": "测试",
							"updated_at": "2021-07-29 14:32:08",
						},{
							"created_at": "2021-07-29 14:32:08",
							"font_in_image": "搜索",
							"id": 3,
							"image": "https://www.wennoanimal.com/uploads/holograms/202107/29//admin_1627540312_NGqESn9dYo.jpg",
							"text": "测试",
							"updated_at": "2021-07-29 14:32:08",
						}],
						"layout": 4,	// 布局：1单列 2二列 3三列 4四列 5五列
						"layout_font_in_image": 1,	// 嵌入文字 1上 2中 3下
						"layout_images_text": 4,	// 图文布局：1上文下图 2下文上图 3左文右图 4 右文左图
						"type": 12,
					},
					{
						"content_color": "#d9d9d9",
						"content_size": "撒啊啊飒飒",
						"id": 1,
						"layout": 2,
						"text": [{
							"content": "sss",
							"id": 3,
							"title": "测试",
						},{
							"content": "sss",
							"id": 3,
							"title": "测试2222222222222222222222222222222222",
						}],
						"title_bold": 1,
						"title_color": "#666666",
						"title_size": "14",
						"type": 13,
					},
				],
			},
		},
		data () {
			return {
			}
		},
		mounted(){
		},
		methods:{
			goProductDtl(path,type){
				console.log('common:',path,type);
				if (path) {
					window.location.href = path
				}
			},
		}
	}
</script>
<style scoped>
.mode_main{width: 100%;}
</style>


// WEBPACK FOOTER //
// src/mode/common.vue